// src/utils/localStorage.js

export const LOCAL_STORAGE_KEYS = {
    selectedLanguageData: "selectedLanguageData",
}

export const setItem = (key, value) => {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch (err) {
    console.error(`Error saving ${key} to localStorage`, err);
  }
};

export const getItem = (key) => {
  try {
    const value = localStorage.getItem(key);
    return value ? JSON.parse(value) : null;
  } catch (err) {
    console.error(`Error reading ${key} from localStorage`, err);
    return null;
  }
};

export const removeItem = (key) => {
  try {
    localStorage.removeItem(key);
  } catch (err) {
    console.error(`Error removing ${key} from localStorage`, err);
  }
};

export const clearStorage = () => {
  try {
    localStorage.clear();
  } catch (err) {
    console.error("Error clearing localStorage", err);
  }
};
